module.exports = __webpack_public_path__ + "static/media/img-desktop-wallpaper-people.679f367a.png";